import React from "react";

function UrlColumnConfig(props) {
  return <div></div>;
}

export default UrlColumnConfig;
